export default "__VITE_PUBLIC_ASSET__c6722af3__"